import { render, staticRenderFns } from "./wxAndAli.vue?vue&type=template&id=8b163bae&scoped=true&"
import script from "./wxAndAli.vue?vue&type=script&lang=js&"
export * from "./wxAndAli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b163bae",
  null
  
)

export default component.exports